import { subscribe } from "valtio";
import { ChatStore } from "@store/modules/chat";

/**
 * 把 `openResponsiveChat` 的 Promise 收敛为「Chat 已打开」的时刻（EDG-581 D5）。
 *
 * `openResponsiveChat` 在三条路径上 resolve 的时机不同：
 * - 委托原生 EdChat / PC 跳 `/chat` → 打开即 resolve；
 * - H5 Chat 弹窗 → 走 react-call 的 `EdgenDrawerCallable.call`，要等弹窗**关闭**才 resolve。
 *
 * H5 弹窗在真正渲染前会同步置 `ChatStore.hasChatModal = true`，这里以它为「已打开」信号：
 * 先到者为准。打开前 opener 抛错仍以 reject 透出；打开之后的 reject 不再影响结果。
 */
export function resolveWhenChatOpened(
  openPromise: Promise<boolean>,
): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    let settled = false;
    let unsubscribe: (() => void) | undefined;
    const settle = (fn: () => void) => {
      if (settled) {
        return;
      }
      settled = true;
      unsubscribe?.();
      fn();
    };

    unsubscribe = subscribe(ChatStore, () => {
      if (ChatStore.hasChatModal) {
        settle(() => resolve(false));
      }
    });

    openPromise.then(
      (value) => settle(() => resolve(value)),
      (error: unknown) => settle(() => reject(error)),
    );
  });
}
